import $ from 'jquery';
import { getCartMachine } from '../../core/cart';
import { onStateChange } from '../../core/stent/subscribe';
const BEFORE_UNLOCK = '.js-cart-before-unlock';
const AFTER_UNLOCK = '.js-cart-after-unlock';
const LOADING_DATA = '.js-cart-loading';
const UNLOCK_VALUE = '.js-cart-bar';
const PROGRESS = '.js-cart-progress';
const CONTAINER = '.CartProgressBar';
const drawerProgressBar = (price)=>{
    const priceVal = price / 100;
    const unlockValue = parseFloat($(UNLOCK_VALUE).attr('unlock-value') || '0');
    if (priceVal > unlockValue) {
        $(BEFORE_UNLOCK).hide();
        $(AFTER_UNLOCK).show();
        $(PROGRESS).css('width', '100%');
    } else {
        const val = priceVal / unlockValue * 100;
        const money = (unlockValue - priceVal).toFixed(2);
        const text = 'You’re' + ' $' + money + ' away from free shipping!';
        $(BEFORE_UNLOCK).show();
        $(AFTER_UNLOCK).hide();
        $(PROGRESS).css('width', val + '%');
        $(BEFORE_UNLOCK).text(text);
    }
    $(CONTAINER).show();
};
export const init = async function() {
    const cartMachine = getCartMachine();
    onStateChange(cartMachine, function updateProgressBar(state) {
        var _state_contents;
        if (state.name !== 'Ready') {
            return;
        }
        $(LOADING_DATA).hide();
        drawerProgressBar((state === null || state === void 0 ? void 0 : (_state_contents = state.contents) === null || _state_contents === void 0 ? void 0 : _state_contents.total_price) || 0);
    });
};
